/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Theme } from '../../enum/theme.enum';
import { StandardAction } from '../../tool/action/standard-action';

export class MenuItem {
  get submenus(): MenuItem[] {
    return this._submenus;
  }

  set submenus(value: MenuItem[]) {
    this._submenus = value;
    this.sortByKeys();
  }
  public id: string;
  public label: string;
  public icon: string;
  public route: string;
  public draggable: boolean;
  public disabled = false;
  private _submenus: MenuItem[];
  public actions: StandardAction[];
  public isSelected = false;
  public theme: Theme;
  public isOpen = false;
  public hasSubMenuSelected = false;
  public firstLevel = false;

  public patternMatcher: RegExp;

  protected sortKeys: string[];

  constructor(id: string, label: string, icon: string, route?: string) {
    this.id = id;
    this.label = label;
    this.icon = icon;
    this.route = route;
    this._submenus = [];
    this.actions = [];
  }
  public hasSubMenus(): boolean {
    return this._submenus && this._submenus.length > 0;
  }
  public hasActions(): boolean {
    return this.actions && this.actions.length > 0;
  }

  public hasSelectedSubMenu(): boolean {
    this.hasSubMenuSelected = this.getSelectedSubMenu() !== undefined;
    return this.hasSubMenuSelected;
  }

  public getSelectedSubMenu() {
    return this._submenus.find((menu: MenuItem) => {
      return menu.isSelected;
    });
  }

  public matchRoute(route: string): MenuItem[] {
    if (route.startsWith('/')) {
      route = route.slice(1, route.length);
    }

    if (this.route) {
      let testingRoute = this.route;
      if (testingRoute.startsWith('/')) {
        testingRoute = testingRoute.slice(1, testingRoute.length);
      }
      if (testingRoute === route) {
        return [this];
      }
    }

    if (this.hasSubMenus()) {
      for (const subMenu of this._submenus) {
        if (subMenu.checkRoute(route)) {
          return [subMenu, this];
        }
      }
    }

    if (this.patternMatcher && this.patternMatcher.test(route)) {
      return [this];
    }

    return [];
  }

  public checkRoute(route: string): boolean {
    const result = this.matchRoute(route);
    switch (result.length) {
      case 0:
        return false;
      case 1:
        this.hasSubMenuSelected = true;
        this.isSelected = true;
        return true;
      default:
        this.hasSubMenuSelected = true;
        this.isSelected = true;
        this.isOpen = true;
        return true;
    }
  }

  public resetSelection() {
    this.isSelected = false;
    if (this.hasSubMenus()) {
      this._submenus.forEach((sm) => sm.resetSelection());
    }
  }

  public sort(keys: string[]) {
    this.sortKeys = keys;
    this.sortByKeys();
  }

  protected sortByKeys() {
    if (this.sortKeys && this._submenus && this._submenus.length > 0) {
      this._submenus.sort((a, b) => {
        return this.sortKeys.indexOf(a.id) - this.sortKeys.indexOf(b.id);
      });
    }
  }
}
